import axiosClient from "./axiosClient";

export const getKnowledgeBases = async (store_id) => {
    try {
        const response = await axiosClient.get(`/stores/${store_id}/knowledge-bases`, {
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error("지식베이스 데이터 로드 중 에러 발생:", error);
        throw error;
    }
};